module.exports = __webpack_public_path__ + "img/card_02@2x.738e0697.png";